import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const authHeader = (token) => ({
  headers: { authorization: `Bearer ${token}` },
});

const getCatalog = async (token) => {
  const response = await axios.get(
    `${BACKEND_URL}api/dashboard-modules`,
    authHeader(token)
  );
  return response;
};

const getAdminCatalog = async (token) => {
  const response = await axios.get(
    `${BACKEND_URL}api/dashboard-modules/admin`,
    authHeader(token)
  );
  return response;
};

const createModule = async (token, payload) => {
  const response = await axios.post(
    `${BACKEND_URL}api/dashboard-modules`,
    payload,
    authHeader(token)
  );
  return response;
};

const updateModule = async (token, key, payload) => {
  const response = await axios.put(
    `${BACKEND_URL}api/dashboard-modules/${key}`,
    payload,
    authHeader(token)
  );
  return response;
};

const deleteModule = async (token, key) => {
  const response = await axios.delete(
    `${BACKEND_URL}api/dashboard-modules/${key}`,
    authHeader(token)
  );
  return response;
};

export default {
  getCatalog,
  getAdminCatalog,
  createModule,
  updateModule,
  deleteModule,
};
